let stateEnum = {
    0: '待确认',
    1: '待审核',
    2: '已通过',
    3: '未通过',
    4: '已作废',
    processState_2: '已合并',
  },
  personStateEnum = {
    0: '无效',
    1: '有效',
  },
  authDisableEnum = {
    0: '有效',
    1: '无效',
  }

  const getDealerList = (identityList = []) => {
    let dealer = {}
    for (let identity of identityList) {
      let {dealerId, dealerName, preSalesNumber, afterSalesNumber} = identity || {}

      if (!!dealerId && dealerId !== -1 && !dealer[dealerId]) {
        dealer[dealerId] = {id: dealerId, name: dealerName, preSalesNumber, afterSalesNumber}
      }
    }
    let dealerList = Object.keys(dealer).map(key => dealer[key]);
    return dealerList;
  }


export {
  stateEnum,
  personStateEnum,
  authDisableEnum,
  getDealerList,
}
